import { render, staticRenderFns } from "./PaperOrganize.vue?vue&type=template&id=ce943694&scoped=true"
import script from "./PaperOrganize.ts?vue&type=script&lang=ts&external"
export * from "./PaperOrganize.ts?vue&type=script&lang=ts&external"
import style0 from "./PaperOrganize.vue?vue&type=style&index=0&id=ce943694&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce943694",
  null
  
)

export default component.exports